module.exports = __webpack_public_path__ + "static/media/400060_01.65011119.png";